import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../Header&Footer/Header";
import InterviewGallery from "./features/InterviewGallery";
import RealtimeInterviewDemo from "./features/RealtimeInterviewDemo";
import ZiaVoiceDemo from "./features/ZiaVoiceDemo";

/**
 * Public "Try it live" demo — reached from the landing page's
 * "Try SearchJob" CTA (route: /hirewithus/demo).
 *
 * Uses the same site Header as the landing page. A gallery of interview
 * personas; picking one launches a real 3-minute AI voice interview whose
 * result is a GENUINE AI evaluation of the candidate's actual answers
 * (scored by the Web-Interviewer backend). No fabricated numbers.
 */
export default function DemoPage() {
  const [params] = useSearchParams();
  const [persona, setPersona] = useState(null);
  // ?talk=1 (e.g. arriving from the booking page) opens Riya's live widget straight away.
  const [view, setView] = useState(params.get("talk") ? "zia" : null); // null (gallery) | "zia"

  let content;
  if (persona) {
    content = (
      <RealtimeInterviewDemo key={persona.id} persona={persona} onBack={() => setPersona(null)} />
    );
  } else if (view === "zia") {
    content = <ZiaVoiceDemo onBack={() => setView(null)} />;
  } else {
    content = <InterviewGallery onPick={setPersona} onTalkToZia={() => setView("zia")} />;
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />

      {/* Header is fixed (h-16) — pad the content so it isn't hidden behind it */}
      <main className="px-4 sm:px-8 pt-24 pb-8">
        <div className="max-w-6xl mx-auto">{content}</div>
      </main>
    </div>
  );
}
